import { Routes, Route, Navigate } from 'react-router-dom'

import DocumentQuotationListView from 'Presentation/Views/Document/Quotation/List/View'
import DocumentQuotationFormView from 'Presentation/Views/Document/Quotation/Form/Main/View'
import { QuotationFormContextProvider } from 'Presentation/Views/Document/Quotation/Form/Context'

const DocumentRoutes = () => (
	<Routes>
		<Route path="quotation">
			<Route index element={<DocumentQuotationListView />} />
			<Route
				path=":id"
				element={
					<QuotationFormContextProvider>
						<DocumentQuotationFormView />
					</QuotationFormContextProvider>
				}
			/>
			<Route path="*" element={<Navigate to="/documents/quotation" replace />} />
		</Route>

		<Route index element={<Navigate to="/documents/quotation" replace />} />
		<Route path="*" element={<Navigate to="/documents/quotation" replace />} />
	</Routes>
)

export default DocumentRoutes
